<template>
  <div class="tableSys pr1x_E vaM_E">
    <div class="w10x">
      <my-select ref="roleSelect" class="w100pct sizeM" @Click='selectLangs' :list="langs" :bindActive="selectActive"></my-select>
    </div>
    <div class="">
      <input-text :placeholder='getLanguageStr("word1963","商家名称")' :maxLength='50' :verification="'notEmpty'" v-model='datavalue' verifyMethod></input-text>
    </div>
    <div class="w5x fSub sizeM" @click="clickB" style="padding-top:1px curP">
      <Icon :name="isAdd?'add':'reduce'" class="w1x h1x curP" :sizeBase="'m'"></Icon>
    </div>
  </div>
</template>
<script>
import MySelect from '@/components/common/ui/Select'
import InputText from '@/components/common/ui/InputText'
import * as lib from '@/util/lib'
import { getLanguageStr } from '@/util/language'
import StatusIco from '@/components/common/ui/StatusIco'

export default {
  name: 'EditInputExtend',
  props: {
    isAdd: { // 判断是加号还是减号
      type: Boolean,
      default: true
    },
    placeKey: {
      type: Number,
      default: 1
    },
    selectActive: {
      type: String,
      default: 1
    },
    value: {
      type: String,
      default: ''
    }
  },
  components: {
    MySelect,
    InputText,
    StatusIco
  },
  watch: {
    datavalue (v) {
      this.$emit('ValueChange', v, this.placeKey)
      // return v
    }
  },
  data () {
    return {
      type: 1,
      langs: [
        { text: '请选择', value: 0,token:true}
      ],
      nowValue: '',
      datavalue: ''
    }
  },
  methods: {
    getLanguageStr,
    show () {
      lib.windowCtrl($('#addMember'), 'true')
    },
    hide () {
      lib.windowCtrl($('#editMember'), 'false')
    },
    selectLangs (index) {
      this.nowValue = index
      // console.log(this.langs[this.nowValue])
      this.$emit('changeLangs', this.langs[this.nowValue].value, this.placeKey, this.selectActive)
    },
    clickB () {
      this.isAdd ? this.$emit('AddName') : this.$emit('ReduceName', this.placeKey, this.nowValue)
    },
    addname () {

    },
    reducename () {

    }
  },
  computed: {},
  mounted () {
    this.nowValue = this.selectActive
    this.langs = stage.languageList
    this.datavalue = this.value
  }
}
</script>
<style lang="scss" scoped>
  .tableSys{
    padding-bottom: 0.5em
  }
</style>



// WEBPACK FOOTER //
// src/view/manage/provider/components/EditInputExtend.vue